import { RootState } from '../reducer';

export const leaveGroupDialogStatusSelector = (state: RootState) => state.groupManagement.leaveGroupDialogStatus;
